




























import {Component, Vue} from 'vue-property-decorator';
import Klokjes from '@/components/Klokjes.vue';
import LocaleService from '@/services/LocaleService';
import {default as GameLogic, Hotspot, HotspotOption} from "../services/GameLogic";
import LocaleText from "../components/LocaleText.vue";
import {TutorialTipPosition} from "../store/store";

@Component({
    components: {LocaleText, Klokjes},
    computed: {
        currentHotspotLabel():string {
            return LocaleService.hotspotDisplayName(this.$store.state, this.$store.state.currentHotspot.name);
        },
        currentHotspotImage():string {
            return GameLogic.getHotspotImage(this.$store.state, this.$store.state.currentHotspot);
        },
        currentOptions():HotspotOption[] {
            console.log(this.$store.state.currentHotspot);
            return GameLogic.getValidHotspotOptions(this.$store.state, this.$store.state.currentHotspot);
        }
    },
    methods: {
        getOptionLabel(name:string):string {
            return LocaleService.optionDisplayName(this.$store.state, this.$store.state.currentHotspot.name, name);
        },
        handleOptionClicked(option:HotspotOption):void {
            let result = LocaleService.hotspotMobileResult(this.$store.state, this.$store.state.currentHotspot.name);
            //console.log(result);
            GameLogic.executeOption(this.$store.state, this.$store.state.currentHotspot, option);
            if( result == '') {
                this.$store.state.currentHotspot = Hotspot.NONE;
                this.$store.state.currentOption = HotspotOption.NONE;
            } else {
                this.$store.state.currentOption = option;
                this.$data.currentResult = result;
            }
            this.$router.push('nurse');
        },
        handleCloseClicked():void {
            this.$store.state.currentHotspot = Hotspot.NONE;
            this.$store.state.currentOption = HotspotOption.NONE;
            this.$router.push('nurse');
        }
    },
    created() {
        this.$store.commit('showTip', {key: 'algemeen.tutorial.tip3.text', position: TutorialTipPosition.top});
    }
})
export default class HotspotMenu extends Vue {
}
